import { put, call, take, fork } from 'redux-saga/effects'
import { cardSelectionPatchService } from '../../api/card'
import { cardSelectionPatchSuccess } from '../../reducers/card/action'
import { CARD_SELECTION_PATCH } from '../../reducers/card/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* cardSelectionPatchFlow(payload) {
  try {
    const { content, questionId, callback } = payload

    yield call(cardSelectionPatchService, content)
    yield put(cardSelectionPatchSuccess(content, questionId))
    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* cardSelectionPatchWatcher() {
  while (true) {
    const action = yield take(CARD_SELECTION_PATCH)
    const { payload } = action

    yield fork(generalSaga, cardSelectionPatchFlow, payload, false)
  }
}
